import React from "react"
import type {
	CheckLimits,
	CheckTotalsDaily,
	CheckTotalsMonthly,
	CheckLimitOverrideInfo,
} from "../../../../resources/account"
import {LimitOverrideType} from "../../../../resources/account"
import RangeBox from "../../../../components/RangeBox/RangeBox"
import {LimitsPageBlockHeader} from "../LimitsPageBlockHeader"
import {buildCheckDepositOverrideInfoProp, getEffectiveCheckDepositLimit} from "../helpers"

const checkDepositLimitItems: {
	description: string
	overrideType: LimitOverrideType
	limitKey: "daily" | "monthly"
	softLimitKey: "dailySoft" | "monthlySoft"
	totalKey: "totalsDaily" | "totalsMonthly"
}[] = [
	{
		description: "(Daily Limit)",
		overrideType: LimitOverrideType.CheckDepositDaily,
		limitKey: "daily",
		softLimitKey: "dailySoft",
		totalKey: "totalsDaily",
	},
	{
		description: "(Monthly Limit)",
		overrideType: LimitOverrideType.CheckDepositMonthly,
		limitKey: "monthly",
		softLimitKey: "monthlySoft",
		totalKey: "totalsMonthly",
	},
]

export function CheckDepositLimitsSection({
	limits,
	total,
	onEditLimit,
	override,
}: {
	limits: CheckLimits
	total: {totalsDaily: CheckTotalsDaily; totalsMonthly: CheckTotalsMonthly}
	onEditLimit?: (limitType: LimitOverrideType) => void
	override?: CheckLimitOverrideInfo
}) {
	return (
		<div className="account-limits-page-section">
			<LimitsPageBlockHeader title="Check Deposit Limits" icon="check-write--business-products" />

			<div className="account-limits-page-grid">
				{checkDepositLimitItems.map(({description, overrideType, limitKey, softLimitKey, totalKey}) => (
					<RangeBox
						key={overrideType}
						title="Check Deposits"
						description={description}
						className="account-limits-page-range-box"
						max={getEffectiveCheckDepositLimit(limits[limitKey], override, overrideType)}
						current={total[totalKey]}
						softLimit={limits[softLimitKey]}
						onEdit={onEditLimit ? () => onEditLimit(overrideType) : undefined}
						overrideInfo={buildCheckDepositOverrideInfoProp(override, overrideType, limits[limitKey])}
					/>
				))}
			</div>
		</div>
	)
}
